import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { OPENING_TASKS_KEYS, openingTasksApi, type MyOpeningPlanDto } from '../../lib/api/openingTasks';
import { retryOpeningQuery } from '../opening-tasks/opening-query';

/**
 * Карточка открытия партнёра целиком для визарда «Открытие точки» (`GET /wiki/opening/plan`, ключ
 * `OPENING_TASKS_KEYS.plan`). 4xx — без повтора: «не про вас» страница решает сама.
 */
export function useOpeningPlan(): UseQueryResult<MyOpeningPlanDto> {
  return useQuery({
    queryKey: OPENING_TASKS_KEYS.plan,
    queryFn: () => openingTasksApi.plan(),
    retry: retryOpeningQuery,
    staleTime: 30_000,
  });
}
